import React from 'react'

import { formatWebinarDate, formatTimeRange } from 'helpers'

import css from './EmbedItem.scss'

const facilitatorLabel = (user) => {
  if (!user) return null
  const name = user.name || [user.first_name, user.last_name].filter(Boolean).join(' ')
  if (!name) return null
  return user.post_nominal_letters ? `${name}, ${user.post_nominal_letters}` : name
}

const EmbedItem = ({ title, href, kind, start, end, facilitator, showDateTime }) => {
  const label = facilitatorLabel(facilitator)

  return (
    <a
      href={href}
      target='_blank'
      rel='noopener noreferrer'
      className={css.item}
    >
      {showDateTime && start && (
        <div className={css.date}>
          {formatWebinarDate(start)}
          {kind === 'webinar' && end && (
            <span className={css.time}>{` · ${formatTimeRange(start, end)}`}</span>
          )}
        </div>
      )}
      <div className={css.title}>{title}</div>
      {label && <div className={css.facilitator}>{label}</div>}
    </a>
  )
}

EmbedItem.propTypes = {
  title: React.PropTypes.string.isRequired,
  href: React.PropTypes.string.isRequired,
  kind: React.PropTypes.string.isRequired,
  start: React.PropTypes.string,
  end: React.PropTypes.string,
  facilitator: React.PropTypes.object,
  showDateTime: React.PropTypes.bool
}

export default EmbedItem
